import { Consume } from "../../../Context/Consumer";
import React, { Component } from "react";
import {
  PlayerListContext,
  TransContext,
  TeamDataContext,
  FixturesContext,
  ConstraintsContext,
} from "../../../Context";
import { getTrans, customTracking } from "../../../common";
import config from "../../../common/config";
import { debounce } from "lodash";

class WebPlayerSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showClose: false,
    };
  }

  handleChange = (event) => {
    this.props.PlayerListData.playerListFilters.searchString =
      event.target.value;
    let budget = this.props.TeamData.data.budget;
    debounce(() => {
      if (this.props.PlayerListData.playerListFilters.searchString) {
      }
      this.props.PlayerListData.setPlayerFilters(
        this.props.PlayerListData.playerListFilters,
        budget
      );
    }, 500)();
    if (event.target.value.length > 0) {
      this.setState({
        showClose: true,
      });
    } else {
      this.setState({
        showClose: false,
      });
    }
  };

  onSearchClose = (e) => {
    e.stopPropagation();
    if (this.props.PlayerListData.playerListFilters.searchString) {
      this.props.PlayerListData.playerListFilters.searchString = "";
      let budget = this.props.TeamData.data.budget;
      this.props.PlayerListData.setPlayerFilters(
        this.props.PlayerListData.playerListFilters,
        budget
      );
      this.setState({
        showClose: false,
      });
    }
  };

  render() {
    let { TransData, PlayerListData } = this.props;
    let trans = TransData.data;

    const res =
      this.state.showClose &&
      this.props.PlayerListData.playerListFilters.searchString.trim() != "";

    return (
      <div className="si-plyrSel__form-list">
        <div className="si-form__control">
          <div
            className={`si-input  ${
              res ? "si-input--clear" : "si-input--search"
            }`}
          >
            <input
              type="text"
              className=""
              placeholder={getTrans(trans,"search","Search")}
              value={PlayerListData.playerListFilters.searchString}
              onChange={(e) => this.handleChange(e)}
            />
            {res ? (
              <div
                className="si-input--icon"
                onClick={(e) => this.onSearchClose(e)}
              ></div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Consume(WebPlayerSearch, [
  PlayerListContext,
  TransContext,
  TeamDataContext,
  FixturesContext,
  ConstraintsContext,
]);
